import React from 'react'
import { IonCard, IonCardTitle, IonCardContent, IonLabel } from '@ionic/react'

import { IVideoYoutube } from '../models/IVideoYoutube'

interface Props {
    item: IVideoYoutube,
    onClick: () => unknown
}

const ItemVideo: React.FC<Props> = (props: Props) => {
  return (
    <IonCard button={true} onClick={props.onClick}>
      <img src={props.item.snippet.thumbnails.medium.url} width="100%" alt={props.item.snippet.title} />
      <IonCardContent>
        <IonCardTitle>{props.item.snippet.title}</IonCardTitle>
        <IonLabel>{props.item.snippet.description.substr(0, 200)}</IonLabel>
      </IonCardContent>
    </IonCard>
  )
}


export default ItemVideo
